<template>
  <div class="container">
    <!-- 轮播图 -->
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#D33A46">
      <van-swipe-item
        v-for="item in bannars"
        :key="item.id"
        @click="swipeClick(item)"
      >
        <van-image class="van-swipe-item" :src="item.image_url" fit="contain" />
      </van-swipe-item>
    </van-swipe>
    <!-- 我的信息 -->
    <div class="user">
      <div v-if="userInfo" class="user-info">
        <van-image
          round
          width="56px"
          height="56px"
          fit="cover"
          :src="userInfo.headimgurl"
        />
        <div class="user-name">
          <div class="user-nick">积分</div>
          <div class="user-Integral">{{ userInfo.score }}</div>
        </div>
      </div>
      <div class="user-button">
        <div class="user-button-wrap">
          <van-image
            width="10px"
            height="10px"
            :src="require('../../assets/img/sign-integer-shop.png')"
          />
          <div class="user-button-text" @click="pushMallClick">积分商城</div>
        </div>
        <div class="user-button-wrap">
          <van-image
            width="10px"
            height="10px"
            :src="require('../../assets/img/sign-integer-shop.png')"
          />
          <div class="user-button-text" @click="scoreDetailClick">积分明细</div>
        </div>
      </div>
    </div>
    <div class="sign" v-if="data">
      <div class="sign-line"></div>
      <div class="sgin-rule" @click="scoreRuleClick">积分规则</div>
      <div class="sgin-tit">
        <span class="sgin-month">{{ data.month + "月" }}</span>
        <span class="sgin-tit-text">签到挑战</span>
      </div>
      <div class="sgin-total">
        <div class="sign-total-tit">
          <span
            >本月累计签到：<span style="color: #d33a46">{{
              data.sign_in_days
            }}</span>
            天</span
          >
        </div>
        <div class="sign-day">
          <div class="sign-day-tit">累计签到得奖励</div>
          <div class="sign-day-slider">
            <div class="sign-day-slider-top">
              <div class="sign-day-slider-top-text"></div>
              <div
                class="sign-day-slider-top-text"
                v-for="item in data.rewards"
                :key="item.days"
              >
                {{ item.days }}天
              </div>
            </div>
            <div class="sign-day-slider-un">
              <div
                class="sign-day-slider-se"
                :style="{ width: sliderWidth + 'px' }"
              ></div>
              <div class="sign-day-slider-dot">
                <div class="sign-day-slider-dot-r"></div>
                <div
                  class="sign-day-slider-dot-r"
                  v-for="item in data.rewards"
                  :key="item.days"
                ></div>
              </div>
            </div>
            <div class="sign-day-slider-bottom">
              <div class="sign-day-slider-bottom-integer-un"></div>
              <div
                class="sign-day-slider-bottom-integer"
                v-for="item in data.rewards"
                :key="item.days"
              >
                +{{ item.points }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="calender-week">
        <div class="calender-week-item">一</div>
        <div class="calender-week-item">二</div>
        <div class="calender-week-item">三</div>
        <div class="calender-week-item">四</div>
        <div class="calender-week-item">五</div>
        <div class="calender-week-item">六</div>
        <div class="calender-week-item">日</div>
      </div>
      <div class="calendar">
        <div
          class="calendar-item"
          :class="[
            item.is_today ? 'calendar-item-today-bgc' : 'calendar-item-day-bgc',
            item == 0 ? 'calendar-item-no-bgc' : '',
          ]"
          v-for="(item, index) in days"
          :key="index"
        >
          <van-image
            v-if="item != 0 && item.limited_time_task"
            class="calendar-item-top"
            width="17px"
            height="17px"
            :src="require('../../assets/img/sign-calendar-top.png')"
          />
          <div v-if="item != 0" class="calendar-item-text">{{ item.day }}</div>
          <van-image
            v-if="item != 0 && item.signed_in"
            class="calendar-item-status"
            width="27px"
            height="27px"
            :src="require('../../assets/img/sign-success-status.png')"
          />
        </div>
      </div>
      <div class="limited-date">
        <van-image
          width="17px"
          height="17px"
          :src="require('../../assets/img/sign-calendar-top.png')"
        />
        <div>限时活动日</div>
      </div>
      <div
        v-if="signInfo && signInfo.is_sign"
        class="now-sign-button now-sign-button-se"
        @click="onSignClick"
      >
        <van-image
          width="17px"
          height="17px"
          :src="require('../../assets/img/sign-go-def.png')"
        />
        <div style="margin-left: 5px">已签到</div>
      </div>
      <div
        v-else
        class="now-sign-button now-sign-button-def"
        @click="onSignClick"
      >
        <van-image
          width="17px"
          height="17px"
          :src="require('../../assets/img/sign-go-se.png')"
        />
        <div style="margin-left: 5px">立即签到</div>
      </div>
    </div>
    <!-- 限时活动 -->
    <div v-if="limitedTimeTask" class="activity">
      <div class="activity-tag">
        <div v-if="limitedTimeTask.completed_times">
          <van-image
            width="100%"
            height="100%"
            :src="require('../../assets/img/sign-activity-tag.png')"
          />
        </div>
        <div v-if="limitedTimeTask.completed_times" class="activity-tag-num">
          {{ limitedTimeTask.completed_times }}
        </div>
      </div>
      <div class="activity-tit">限时活动</div>
      <div class="activity-con">
        <div class="activity-con-left">
          <div class="activity-con-tit">{{ limitedTimeTask.title }}</div>
          <div class="activity-con-subtit">
            <span>{{ limitedTimeTask.description }}</span>
            <span>，每次可获得</span>
            <span style="margin: 0 3px; color: #d33a46; font-weight: 600">{{
              limitedTimeTask.reward_score
            }}</span>
            <span>积分</span>
            <div
              v-if="limitedTimeTask.goal.url"
              class="activity-con-link"
              @click="onActivityLinkClick"
            >
              查看详细规则
            </div>
          </div>
        </div>
        <div
          class="activity-con-right"
          @click="onLimiteJoinClick(limitedTimeTask)"
        >
          去发布
        </div>
      </div>
    </div>
    <!-- 日常任务 -->
    <div class="task">
      <div class="task-top">
        <div class="task-tit">日常任务</div>
        <div class="task-all" @click="allTaskClick"></div>
      </div>
      <div class="task-con">
        <div
          class="task-con-item"
          v-for="item in daily_tasks"
          :key="item.task_id"
          @click="taskItemClick(item)"
        >
          <div class="task-con-icon">
            <van-image
              width="50px"
              height="50px"
              :src="getTaskTypeImg(item.goal_type)"
            />
          </div>
          <div class="task-con-info">
            <div class="task-con-info-tit">
              {{ item.title
              }}<span v-if="item.goal_type == 'invite_register'">{{
                "（已邀请" + item.completed_times + "人）"
              }}</span>
            </div>
            <div
              v-if="item.goal_type == 'complete_profile'"
              class="task-con-info-subtit"
            >
              <span>{{ item.description }}</span>
              <span>，最多可获得</span>
              <span style="margin: 0 3px; color: #d33a46; font-weight: 600">{{
                item.reward_score
              }}</span>
              <span>积分</span>
            </div>
            <div v-else class="task-con-info-subtit">
              <span>{{ item.description }}</span>
              <span>，可获得</span>
              <span style="margin: 0 3px; color: #d33a46; font-weight: 600">{{
                item.reward_score
              }}</span>
              <span>积分</span>
            </div>
          </div>
          <div
            v-if="item.completed && item.goal_type != 'invite_register'"
            class="task-con-btn task-con-btn-red"
          >
            已完成
          </div>
          <div v-else class="task-con-btn task-con-btn-blue">去完成</div>
        </div>
      </div>
    </div>
    <!-- 签到成功弹窗 -->
    <van-overlay class="sign-success-overlay" :show="signSuccessShow">
      <div class="wrapper">
        <van-image
          class="success-img-top"
          :src="require('../../assets/img/sign-overly-top.png')"
        ></van-image>
        <div class="content">
          <div class="success-text">签到成功！</div>
          <div class="success-source">
            恭喜获得积分<span class="number">+{{ signScore }}</span>
          </div>
          <div class="success-close" @click="onSignSuccessOverlayClick">
            关闭
          </div>
        </div>
        <van-image
          class="success-img"
          :src="require('../../assets/img/sign-overly-success.png')"
        ></van-image>
      </div>
    </van-overlay>
    <!-- 邀请好友弹窗 -->
    <van-overlay class="sign-invite-overlay" :show="signInviteShow">
      <div class="wrapper">
        <van-image
          class="success-img-top"
          :src="require('../../assets/img/sign-overly-top.png')"
        ></van-image>
        <div class="content">
          <div class="tip">复制以下链接，微信发送好友</div>
          <div class="text">
            点击下方链接，和我一起加入【丘比粉丝俱乐部】吧，解锁趣味互动，畅享专属福利！海量惊喜等你来嗨～
            {{ signInviteLink }}
          </div>
          <div class="copy" @click="onCopyInviteLinkClick">复制</div>
          <van-image
            class="close"
            :src="require('../../assets/img/sign-invite-close.png')"
            @click="onSignInviteOvelayClick"
          ></van-image>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { getBanners, getOverview, getSign, getSignInfo } from "network/sign";
import { Toast } from "vant";

export default {
  name: "NewSign",
  data() {
    return {
      userInfo: null,
      bannars: [],
      data: null,
      days: [],
      sliderWidth: 0,
      signInfo: {},
      signScore: 0,
      signSuccessShow: false,
      signInviteShow: false,
      daily_tasks: [],
      limitedTimeTask: null,
      signInviteLink: "",
    };
  },
  computed: {
    getTaskTypeImg() {
      return (type) => {
        if (type == "post_topic") {
          // 发布帖子
          return require("../../assets/img/sign-task-topic.png");
        } else if (type == "like_topic") {
          // 点赞帖子
          return require("../../assets/img/sign-task-praise.png");
        } else if (type == "favorite_topic") {
          // 收藏帖子
          return require("../../assets/img/sign-task-coll.png");
        } else if (type == "reply_topic") {
          // 评论帖子
          return require("../../assets/img/sign-task-comment.png");
        } else if (type == "complete_profile") {
          // 完善个人资料
          return require("../../assets/img/sign-task-profile.png");
        } else {
          // 邀请注册
          return require("../../assets/img/sign-task-register.png");
        }
      };
    },
  },
  created() {
    this.requestGetSignInfo();
    this.requestGetBanners();
    this.requestGetOverview();
  },
  methods: {
    // 请求banner
    requestGetBanners() {
      getBanners().then((res) => {
        this.bannars = res.data;
      });
    },
    requestGetOverview() {
      let toast = Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      getOverview()
        .then((res) => {
          this.data = res.data;
          // 计算任务进度
          let lastElement = res.data.rewards.slice(-1)[0];
          let e = res.data.sign_in_days / lastElement.days;
          this.sliderWidth = 234 * e;
          // 重新整理日历
          let array = [];
          let firstDayWeek = res.data.calendar[0];
          for (let index = 1; index < firstDayWeek.day_of_week; index++) {
            array.push(0);
          }
          let days = array.concat(res.data.calendar);
          this.days = days;

          // 日常任务
          let daily_tasks = res.data.daily_tasks;
          daily_tasks = daily_tasks.concat(res.data.one_time_tasks);
          daily_tasks = daily_tasks.concat(res.data.weekly_tasks);
          this.daily_tasks = daily_tasks;
          // 限时任务
          if (res.data.limited_time_tasks.length > 0) {
            this.limitedTimeTask = res.data.limited_time_tasks[0];
          }
          toast.close();
        })
        .catch((err) => {
          toast.close();
        });
    },
    // 获取签到信息
    requestGetSignInfo() {
      getSignInfo().then((res) => {
        this.signInfo = res.data;
        this.userInfo = res.data.user;
      });
    },
    // 签到
    requestToSign() {
      getSign().then((res) => {
        this.signInfo.is_sign = true;
        this.signInfo.sign_count++;
        this.signScore = res.score;
        this.signSuccessShow = true;
        this.requestGetSignInfo();
        this.requestGetOverview();
      });
    },
    // 点击banner
    swipeClick(item) {
      if (item.link_url) {
        window.location.href = item.link_url;
      }
    },
    //进入积分商城
    pushMallClick() {
      this.$router.push({ path: "/mall" });
    },
    //积分规则
    scoreRuleClick() {
      this.$router.push({ path: "/integralrules" });
    },
    //积分明细
    scoreDetailClick() {
      this.$router.push({ path: "/mallrecord" });
    },
    //全部任务
    allTaskClick() {
      this.$router.push({ path: "/alltask" });
    },
    // 立即签到
    onSignClick() {
      if (this.signInfo.is_sign) {
        return;
      }
      this.requestToSign();
    },
    // 点击任务
    taskItemClick(item) {
      if (item.completed && item.goal_type != "invite_register") {
        return;
      }
      if (item.goal_type == "post_topic") {
        this.$router.push({ path: "/release" });
      } else if (item.goal_type == "like_topic") {
        this.$router.push({ path: "/home" });
      } else if (item.goal_type == "favorite_topic") {
        this.$router.push({ path: "/home" });
      } else if (item.goal_type == "reply_topic") {
        this.$router.push({ path: "/home" });
      } else if (item.goal_type == "complete_profile") {
        this.$router.push({ path: "/infowrittenconsent" });
      } else if (item.goal_type == "invite_register") {
        this.signInviteLink = item.goal.invite_url;
        this.signInviteShow = true;
      }
    },
    // 复制邀请链接
    onCopyInviteLinkClick() {
      this.signInviteShow = false;
      this.$copyText(
        "点击下方链接，和我一起加入【丘比粉丝俱乐部】吧，解锁趣味互动，畅享专属福利！海量惊喜等你来嗨～" +
          this.signInviteLink
      )
        .then(() => {
          Toast.success("链接已复制到剪贴板");
        })
        .catch(() => {
          Toast.fail("复制失败，请手动复制");
        });
    },
    // 点击限时活动
    onLimiteJoinClick(item) {
      if (item.goal_type == "post_topic") {
        this.$router.push({ path: "/release" });
      } else if (item.goal_type == "like_topic") {
        this.$router.push({ path: "/home" });
      } else if (item.goal_type == "favorite_topic") {
        this.$router.push({ path: "/home" });
      } else if (item.goal_type == "reply_topic") {
        this.$router.push({ path: "/home" });
      } else if (item.goal_type == "perfect_profile") {
        this.$router.push({ path: "/edit" });
      } else if (item.goal_type == "invite_register") {
        this.signInviteLink = item.goal.invite_url;
        this.signInviteShow = true;
      } else if (item.goal_type == "post_topic_with_keyword") {
        this.$router.push({ path: "/release" });
      }
    },
    // 点击限时活动规则
    onActivityLinkClick() {
      if (this.limitedTimeTask.goal.url) {
        window.location.href = this.limitedTimeTask.goal.url;
      }
    },
    //关闭签到成功弹窗
    onSignSuccessOverlayClick() {
      this.signSuccessShow = false;
    },
    //关闭邀请好友弹窗
    onSignInviteOvelayClick() {
      this.signInviteShow = false;
    },
  },
};
</script>
<style scoped>
.container {
  padding-top: 15px;
  padding-bottom: 80px;
  width: 100%;
  min-height: 100vh;
  background: #faf0f0;
  overflow-x: hidden;
}
.my-swipe {
  margin: 0 15px 15px 15px;
  border-radius: 22px;
}
.van-swipe-item {
  height: 150px;
  width: 100%;
  font-size: 20px;
  text-align: center;
}
.user {
  margin: 15px 15px 0 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-radius: 22px;
  background-color: #fff;
}
.user-info {
  display: flex;
}
.user-name {
  margin-left: 10px;
}
.user-nick {
  margin-top: 6px;
  font-size: 10px;
  color: #969799;
}
.user-Integral {
  font-size: 20px;
  color: #333;
}
.user-button {
  display: flex;
  align-items: center;
}
.user-button-wrap {
  margin-left: 10px;
  display: flex;
  justify-content: center;
  height: 20px;
  width: 70px;
  align-items: center;
  font-size: 10px;
  color: #d33a46;
  border-radius: 10px;
  background-color: #faf0f0;
}
.user-button-text {
  margin-left: 2px;
}
.sign {
  position: relative;
  margin: 0px 15px 0 15px;
  padding: 0 20px 20px 20px;
  border-radius: 22px;
  background-color: #fff;
}
.sign-line {
  position: absolute;
  top: 0;
  left: 40px;
  width: 270px;
  height: 1px;
  border-top: 1px dashed #d33a46;
}
.sgin-rule {
  padding-top: 5px;
  display: flex;
  justify-content: end;
  font-size: 10px;
  text-decoration: underline;
  color: #707070;
}
.sgin-tit {
  text-align: center;
}
.sgin-month {
  font-size: 16px;
  font-weight: 600;
  color: #d33a46;
}
.sgin-tit-text {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
.sgin-total {
  margin-top: 22px;
  padding: 10px;
  border-radius: 12px;
  background-color: #fff2f3;
  text-align: center;
}
.sign-total-tit {
  display: inline-block;
  margin: auto;
  padding: 0 15px;
  height: 20px;
  line-height: 20px;
  font-size: 9px;
  border-radius: 10px;
  background-color: #fff;
}
.sign-day {
  display: flex;
  margin-top: 14px;
  align-items: center;
  justify-content: space-between;
  font-size: 9px;
}
.sign-day-tit {
  width: 36px;
}
.sign-day-slider {
  width: 230px;
}
.sign-day-slider-top {
  margin-left: -7px;
  width: 240px;
  display: flex;
  justify-content: space-between;
  font-size: 9px;
  font-weight: 600;
}
.sign-day-slider-top-text {
  width: 25px;
}
.sign-day-slider-un {
  position: relative;
  margin-top: 10px;
  width: 100%;
  height: 4px;
  background-color: #fff;
}

.sign-day-slider-se {
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  height: 4px;
  background-color: #d33a46;
}
.sign-day-slider-dot {
  position: absolute;
  top: -2px;
  left: -2px;
  width: 230px;
  height: 8px;
  display: flex;
  justify-content: space-between;
}
.sign-day-slider-dot-r {
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: #ed5b5b;
}

.sign-day-slider-bottom {
  margin-left: -7px;
  margin-top: 10px;
  width: 240px;
  display: flex;
  justify-content: space-between;
  font-size: 9px;
  font-weight: 600;
}
.sign-day-slider-bottom-integer {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background-image: url("../../assets/img/sign-slider-intger.png");
  background-size: cover;
  background-position: center;
}
.sign-day-slider-bottom-integer-un {
  width: 20px;
  height: 20px;
  line-height: 20px;
}
.calender-week {
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
  border-radius: 5px;
  /* background-color: #ffebed; */
  background-color: #f5f5f5;
}
.calender-week-item {
  text-align: center;
  font-size: 12px;
  font-weight: 600;
}
.calendar {
  margin-top: 5px;
  display: flex;
  flex-wrap: wrap;
}

.calendar-item {
  position: relative;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  margin-right: 5px;
  margin-bottom: 5px;
  width: 39px;
  height: 48px;
  border-radius: 7px;
}
.calendar-item-top {
  position: absolute;
  top: -5px;
  right: -5px;
}
.calendar-item-today-bgc {
  background-color: #fff2f3;
}
.calendar-item-day-bgc {
  background-color: #bae5ff;
}
.calendar-item-no-bgc {
  background-color: #fff;
}

.calendar-item:nth-child(7n) {
  margin-right: 0px;
}
.calendar-item-text {
  margin-top: 8px;
  text-align: center;
  font-size: 12px;
  color: #333;
}
.calendar-item-status {
  margin-top: -2px;
}
.limited-date {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 12px;
  color: #d33a46;
}
.now-sign-button {
  margin: auto;
  margin-top: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 166px;
  height: 40px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}
.now-sign-button-def {
  color: #d33a46;
  background-color: #ffebed;
}
.now-sign-button-se {
  color: #fff;
  background-color: #b4b3b3;
}

.activity {
  position: relative;
  margin: 15px;
}
.activity-tag {
  position: absolute;
  right: -10px;
  top: -10px;
  width: 80px;
  height: 80px;
  transform: rotate(-20deg);
}
.activity-tag-num {
  position: absolute;
  width: 80px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  top: 19px;
  left: 0px;
  font-size: 20px;
  font-weight: 600;
  color: #d33a46;
}

.activity-tit {
  margin-left: 10px;
  width: 106px;
  height: 50px;
  line-height: 30px;
  font-size: 12px;
  text-align: center;
  color: #fff;
  background-color: #d33a46;
  border-top-left-radius: 17px;
  border-top-right-radius: 17px;
}
.activity-con {
  margin-top: -20px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 20px;
  background-color: #fff;
}
.activity-con-left {
  margin-right: 20px;
}
.activity-con-tit {
  font-size: 14px;
  font-weight: 600;
}
.activity-con-subtit {
  font-size: 12px;
}
.activity-con-link {
  text-decoration: underline;
  color: #46aef7;
}
.activity-con-right {
  min-width: 72px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  border-radius: 9px;
  font-size: 12px;
  color: #fff;
  background-color: #d33a46;
}
.task {
  margin: 15px;
}
.task-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
}
.task-tit {
  margin-left: 10px;
  width: 106px;
  height: 50px;
  line-height: 30px;
  text-align: center;
  color: #fff;
  background-color: #d33a46;
  border-top-left-radius: 17px;
  border-top-right-radius: 17px;
}
.task-all {
  margin-right: 10px;
  margin-top: -20px;
  color: #d33a46;
}
.task-con {
  position: relative;
  margin-top: -20px;
  padding: 0 20px;
  border-radius: 20px;
  background-color: #fff;
  z-index: 1;
}
.task-con-item {
  padding: 20px 0;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f5f2f2;
}
.task-con-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 50px;
  min-height: 50px;
  border-radius: 25px;
  background-color: #ffebed;
}
.task-con-info {
  margin-left: 10px;
  font-size: 12px;
}
.task-con-info-tit {
  font-size: 14px;
  font-weight: 600;
  color: #d33a46;
}
.task-con-info-subtit {
  color: #333;
}
.task-con-btn {
  margin-left: 20px;
  min-width: 50px;
  height: 20px;
  line-height: 20px;
  font-size: 10px;
  text-align: center;
  border-radius: 10px;
  color: #fff;
}
.task-con-btn-red {
  background-color: #b4b3b3;
}
.task-con-btn-blue {
  background-color: #d33a46;
}

.sign-success-overlay {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10;
  height: 100vh;
}
.sign-success-overlay .wrapper {
  position: relative;
  width: 248px;
  height: 232px;
}
.sign-success-overlay .wrapper .success-img-top {
  width: 100%;
  height: 70px;
}
.sign-success-overlay .wrapper .success-img {
  position: absolute;
  top: 45px;
  left: 64px;
  width: 120px;
  height: 53px;
}
.sign-success-overlay .wrapper .content {
  margin-top: -6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 162px;
  border-bottom-right-radius: 26px;
  border-bottom-left-radius: 26px;
  background-color: #fff;
}
.sign-success-overlay .wrapper .content .success-text {
  font-size: 12px;
  font-weight: 600;
  color: #d33a46;
}
.sign-success-overlay .wrapper .content .success-source {
  font-size: 12px;
  font-weight: 600;
}
.sign-success-overlay .wrapper .content .success-source .number {
  margin-left: 5px;
  font-size: 20px;
  font-weight: 600;
  color: #d33a46;
}
.sign-success-overlay .wrapper .content .success-close {
  margin-top: 10px;
  height: 38px;
  width: 85px;
  line-height: 38px;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  border-radius: 19px;
  color: #d33a46;
  background-color: #ffebed;
}
.sign-invite-overlay {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10;
  height: 100vh;
}
.sign-invite-overlay .wrapper {
  position: relative;
  width: 248px;
}
.sign-invite-overlay .wrapper .success-img-top {
  width: 100%;
  height: 70px;
}
.sign-invite-overlay .wrapper .content {
  margin-top: -6px;
  padding: 15px;
  width: 100%;
  border-bottom-right-radius: 26px;
  border-bottom-left-radius: 26px;
  background-color: #fff;
}
.sign-invite-overlay .wrapper .content .tip {
  font-size: 12px;
  font-weight: 600;
  color: #d33a46;
}
.sign-invite-overlay .wrapper .content .text {
  margin-top: 10px;
  padding: 5px;
  font-size: 12px;
  color: #333;
  background-color: #f4f4f4;
  word-wrap: break-word;
}
.sign-invite-overlay .wrapper .content .copy {
  margin: 10px auto 0 auto;
  height: 38px;
  width: 85px;
  line-height: 38px;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  border-radius: 19px;
  color: #d33a46;
  background-color: #ffebed;
}
.sign-invite-overlay .wrapper .content .close {
  position: absolute;
  bottom: -50px;
  left: 112px;
  width: 24px;
  height: 24px;
}
</style>